export default {
  // START:: SET APP LOCALE
  setAppLocale(state, payload) {
    state.perfermo_provider_dashboard_language = payload;
  },
  // END:: SET APP LOCALE
};
